import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import * as Sentry from '@sentry/angular';

@Injectable()
export class ErrorService {
  constructor() {}

  handleError = (error: any) => {
    const exception =
      error.error || error.message || error.originalError || error;
    Sentry.captureException(exception);
    throwError(error);
  };
}
